import { useQuery } from '@tanstack/react-query'
import { useGenerateCompanyPath } from '@/libs'
import { gameQueryOptions } from '@/layouts/game'
import { useGameSettingsQuery } from '../../api/useGameSettingsQuery'
import { localesQueryOptions } from '../localization'
import { GameSettingsForm } from './forms/GameSettingsForm'

export const GameSettingsPage = () => {
  const { companyId, gameId } = useGenerateCompanyPath()

  const { data: game, isLoading: isLoadingGame } = useQuery(gameQueryOptions(companyId, gameId))
  const { data: settings, isLoading: isLoadingSettings } = useGameSettingsQuery(companyId, gameId)
  const { data: locales = [] } = useQuery(localesQueryOptions(companyId, gameId))

  if (isLoadingGame || isLoadingSettings || !game) {
    return null
  }

  return (
    <div className="flex size-full flex-col">
      <GameSettingsForm
        values={{
          game: game,
          settings: settings ?? undefined,
        }}
        locales={locales}
      />
    </div>
  )
}
